import styled from "styled-components";

export const FranchisePubPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const FranchisePubPopupBox = styled.div`
  width: calc(100% - 40px);
  height: 80%;
  background-color: #fff;
  border-radius: 12px;

  display: flex;
  flex-direction: column;

  align-items: center;

  gap: 20px;
`;

export const FranchisePubPopupTitle = styled.div`
  padding: 20px 16px 0px;
  color: #202020;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%; /* 28px */
`;

export const FranchisePubPopupListWrapper = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;

  padding: 0 16px;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FranchisePubPopupItem = styled.div<{ selected: boolean }>`
  width: 100%;
  height: 50px;

  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? "#6436e7" : "#B7B7B7")};
  background-color: ${({ selected }) => (selected ? "#6436e7" : "#fff")};
  border-radius: 8px;
  color: ${({ selected }) => (selected ? "#fff" : "#000")};
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .pub {
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .distance {
    text-align: right;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const FranchisePubPopupButtonWrapper = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
`;

export const FranchisePubPopupLeftButton = styled.div`
  flex: 1;
  height: 48px;
  border-radius: 0 0 0 12px;
  background: #fff;

  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--Purple-300, #6436e7);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;

export const FranchisePubPopupRightButton = styled.div`
  flex: 1;
  height: 48px;
  border-radius: 0 0 12px 0;
  background: var(--Purple-300, #6436e7);

  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;
